import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectCentralizedDispatchStore = (state) => state.centralizedDispatch;

export const makeSelectReports = () => createSelector(
  selectCentralizedDispatchStore,
  ({ reports }) => reports,
);

export const makeSelectUsedReport = () => createSelector(
  selectCentralizedDispatchStore,
  ({ usedReport }) => usedReport,
);

export const makeSelectTripsSearchCriteria = () => createSelector(
  selectCentralizedDispatchStore,
  ({ tripsSearchCriteria }) => tripsSearchCriteria,
);

export const makeSelectTripsOrderFields = () => createSelector(
  selectCentralizedDispatchStore,
  ({ tripsOrderFields }) => tripsOrderFields,
);

export const makeSelectDriversSearchCriteria = () => createSelector(
  selectCentralizedDispatchStore,
  ({ driversSearchCriteria }) => driversSearchCriteria,
);

export const makeSelectDriversRadiusRequestParams = () => createSelector(
  selectCentralizedDispatchStore,
  ({ driversRadiusRequestParams }) => driversRadiusRequestParams,
);
